import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import DigitalePrSenzNeuDefiniert from "./sections/DigitalePrSenzNeuDefiniert";
import Expertise from "./sections/Expertise";
import Branchen from "./sections/Branchen";
import Prozess from "./sections/Prozess";
import Portfolio from "./sections/Portfolio";
import Initiate from "./sections/Initiate";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <DigitalePrSenzNeuDefiniert />
      <Expertise />
      <Branchen />
      <Prozess />
      <Portfolio />
      <Initiate />
      <Footer />
    </div>;
}